var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "app-main"
  }, [(_vm.product) ? _c('div', {
    class: _vm.productContainerClass
  }, [_c('div', {
    staticClass: "product__left-panel"
  }, [_c('div', {
    staticClass: "item inside-item item--style-2",
    attrs: {
      "data-animation-path-duration": "1500",
      "data-animation-path-easing": "easeOutElastic",
      "data-morph-path": "M 418.1,159.8 C 460.9,222.9 497,321.5 452.4,383.4 417.2,432.4 371.2,405.6 271.3,420.3 137.2,440 90.45,500.6 42.16,442.8 -9.572,381 86.33,289.1 117.7,215.5 144.3,153.4 145.7,54.21 212.7,36.25 290.3,15.36 373.9,94.6 418.1,159.8 Z",
      "data-path-scaleY": "1.1",
      "data-image-scaleX": "1.3",
      "data-image-scaleY": "1.3",
      "data-animation-deco-duration": "2000",
      "data-animation-deco-delay": "100",
      "data-deco-rotate": "-10"
    }
  }, [_c('div', {
    class: _vm.productClass
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "data-item-image": _vm.product.image,
      "src": _vm.product.image,
      "alt": "Product"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product__bottom product__deta-btn"
  }, [_c('a', {
    staticClass: "btn product__bottom--button",
    attrs: {
      "target": "_blank",
      "id": "d",
      "href": _vm.product.redirect_to
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "32",
      "height": "28",
      "viewBox": "0 0 32 28"
    }
  }, [_c('defs', [_c('path', {
    staticClass: "product__shape",
    attrs: {
      "id": "a",
      "d": "M1064.97 590.08l-2.41 11.38c-.12.6-.67 1.04-1.3 1.04h-18.41l.67 3.5h16.44c.64 0 1.15.43 1.3.99a3.49 3.49 0 0 1-2.48 6.01 3.53 3.53 0 0 1-3.56-3.5c0-.61.17-1.22.48-1.75h-8.07c.32.53.48 1.14.48 1.75 0 1.93-1.59 3.5-3.55 3.5a3.53 3.53 0 0 1-3.56-3.5c0-.91.35-1.73.92-2.35l-3.88-20.4h-4.37a.66.66 0 0 1-.67-.66v-.43c0-.37.3-.66.67-.66h4.74c.64 0 1.19.45 1.31 1.07l.46 2.43h23.49c.84 0 1.47.77 1.3 1.58zm-20.41 17.67c-.98 0-1.78.79-1.78 1.75s.8 1.75 1.78 1.75 1.77-.79 1.77-1.75-.79-1.75-1.77-1.75zm16 1.75c0-.96-.8-1.75-1.78-1.75s-1.78.79-1.78 1.75.8 1.75 1.78 1.75 1.78-.79 1.78-1.75zm2.56-19.25h-22.6l2 10.5h18.38z"
    }
  })]), _c('g', {
    attrs: {
      "transform": "translate(-1033 -585)"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#a"
    }
  })])]), _vm._v("\n                                Купи онлайн\n                            ")])])]), _vm._v(" "), _c('svg', {
    staticClass: "item__svg",
    attrs: {
      "width": "500px",
      "height": "500px",
      "viewBox": "0 0 500 500"
    }
  }, [_c('clipPath', {
    attrs: {
      "id": "clipShape2"
    }
  }, [_c('path', {
    staticClass: "item__clippath",
    attrs: {
      "d": "M 378.1,121.2 C 408.4,150 417.2,197.9 411,245.8 404.8,293.7 383.5,341.7 353.4,370.7 303.2,419.1 198.7,427.7 144.5,383.8 86.18,336.5 67.13,221.3 111.9,161 138.6,125 188.9,99.62 240.7,90.92 292.4,82.24 345.6,90.32 378.1,121.2 Z"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "clip-path": "url(#clipShape2)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0,0h600v600H0V0z"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "product__right-panel"
  }, [_c('div', {
    staticClass: "product__description"
  }, [_c('div', {
    staticClass: "product__first-section"
  }, [_c('div', {
    staticClass: "product__first-section--content"
  }, [_c('div', {
    staticClass: "product__titles"
  }, [_c('h1', {
    staticClass: "product__big-title",
    attrs: {
      "data-item-name": _vm.product.title
    },
    domProps: {
      "textContent": _vm._s(_vm.product.title)
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "product__sub-title",
    domProps: {
      "textContent": _vm._s(_vm.product.sub_title)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "product__content"
  }, [_c('p', {
    staticClass: "product__description--text",
    domProps: {
      "innerHTML": _vm._s(_vm.product.short_description)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "product__bottom"
  }, [_c('div', {
    staticClass: "product__bottom--details",
    on: {
      "click": function($event) {
        _vm.detailClicked()
      }
    }
  }, [_vm._v("Детайлно описание\n                                        "), _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "22",
      "height": "10",
      "viewBox": "0 0 22 10"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(-959 -595)"
    }
  }, [_c('path', {
    attrs: {
      "id": "b",
      "d": "M981 595.62a.64.64 0 0 0-.05-.24.77.77 0 0 0-.69-.38.8.8 0 0 0-.53.18l-9.81 8.31-9.67-8.2a.8.8 0 0 0-.52-.18c-.2 0-.37.06-.51.18a.55.55 0 0 0-.22.45c0 .17.07.32.22.44l10.19 8.64c.14.12.31.18.51.18.21 0 .38-.06.52-.18l10.34-8.76a.56.56 0 0 0 .17-.21.68.68 0 0 0 .05-.23z"
    }
  })])])]), _vm._v(" "), _c('a', {
    staticClass: "btn product__bottom--button",
    attrs: {
      "target": "_blank",
      "id": "detail",
      "href": _vm.product.redirect_to
    }
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "width": "32",
      "height": "28",
      "viewBox": "0 0 32 28"
    }
  }, [_c('defs', [_c('path', {
    staticClass: "product__shape",
    attrs: {
      "id": "a",
      "d": "M1064.97 590.08l-2.41 11.38c-.12.6-.67 1.04-1.3 1.04h-18.41l.67 3.5h16.44c.64 0 1.15.43 1.3.99a3.49 3.49 0 0 1-2.48 6.01 3.53 3.53 0 0 1-3.56-3.5c0-.61.17-1.22.48-1.75h-8.07c.32.53.48 1.14.48 1.75 0 1.93-1.59 3.5-3.55 3.5a3.53 3.53 0 0 1-3.56-3.5c0-.91.35-1.73.92-2.35l-3.88-20.4h-4.37a.66.66 0 0 1-.67-.66v-.43c0-.37.3-.66.67-.66h4.74c.64 0 1.19.45 1.31 1.07l.46 2.43h23.49c.84 0 1.47.77 1.3 1.58zm-20.41 17.67c-.98 0-1.78.79-1.78 1.75s.8 1.75 1.78 1.75 1.77-.79 1.77-1.75-.79-1.75-1.77-1.75zm16 1.75c0-.96-.8-1.75-1.78-1.75s-1.78.79-1.78 1.75.8 1.75 1.78 1.75 1.78-.79 1.78-1.75zm2.56-19.25h-22.6l2 10.5h18.38z"
    }
  })]), _c('g', {
    attrs: {
      "transform": "translate(-1033 -585)"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#a"
    }
  })])]), _vm._v("\n\t\t\t\t\t\t\t\t\t\tКупи онлайн\n\t\t\t\t\t\t\t\t\t")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "product__second-section"
  }, [_c('div', {
    staticClass: "product__content"
  }, [_c('h1', {
    staticClass: "product__detail-title"
  }, [_vm._v("Детайлно описание")]), _vm._v(" "), _c('div', {
    staticClass: "product__description",
    domProps: {
      "innerHTML": _vm._s(_vm.product.description)
    }
  })]), _vm._v(" "), (_vm.product && _vm.product.certificates) ? _c('section', {
    staticClass: "certificates",
    domProps: {
      "innerHTML": _vm._s(this.$root.$data.settings.certificates)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.product.articles && _vm.product.articles.length) ? _c('Articles', {
    attrs: {
      "articles": _vm.product.articles
    }
  }) : _vm._e()], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.settings) ? _c('div', {
    staticClass: "product__footerbar"
  }, [_c('h3', {
    staticClass: "product__footerbar--title",
    domProps: {
      "innerHTML": _vm._s(_vm.settings.footer_title)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "product__footerbar--text",
    domProps: {
      "innerHTML": _vm._s(_vm.settings.footer_description)
    }
  })]) : _vm._e()])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0739c555","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InsideProduct.vue
// module id = EOGT
// module chunks = 1